import * as React from 'react';
import { Questionnaire as QuestionnairePrimitive } from '@shadcn/react/questionnaire';
import { cn } from '@/lib/utils';
import { Button } from './Button';

function Questionnaire({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Root>) {
  return <QuestionnairePrimitive.Root className={cn('flex w-full min-w-0 flex-col', className)} {...props} />;
}

function QuestionnaireProgress({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Progress>) {
  return <QuestionnairePrimitive.Progress className={cn('w-fit text-xs font-medium text-muted-foreground tabular-nums', className)} {...props} />;
}

function QuestionnaireItem({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Item>) {
  return <QuestionnairePrimitive.Item className={cn('min-w-0 border-0 p-0 outline-none not-data-active:hidden', className)} {...props} />;
}

function QuestionnaireTitle({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Title>) {
  return <QuestionnairePrimitive.Title className={cn('font-heading text-base font-medium leading-none', className)} {...props} />;
}

function QuestionnaireDescription({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Description>) {
  return <QuestionnairePrimitive.Description className={cn('mt-1.5 text-sm leading-5 text-muted-foreground', className)} {...props} />;
}

function QuestionnaireChoices({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Choices>) {
  return <QuestionnairePrimitive.Choices className={cn('mt-5 grid gap-2', className)} {...props} />;
}

function QuestionnaireChoice({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Choice>) {
  return <QuestionnairePrimitive.Choice className={cn('flex cursor-pointer items-center gap-3 rounded-xl border bg-card p-3 text-sm transition hover:bg-muted/50 data-checked:border-foreground/25 data-checked:bg-muted', className)} {...props} />;
}

function QuestionnaireChoiceInput(props: React.ComponentProps<typeof QuestionnairePrimitive.ChoiceInput>) {
  return <QuestionnairePrimitive.ChoiceInput className="size-4 accent-foreground" {...props} />;
}

function QuestionnaireChoiceLabel({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.ChoiceLabel>) {
  return <QuestionnairePrimitive.ChoiceLabel className={cn('font-medium', className)} {...props} />;
}

function QuestionnaireError({ className, ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Error>) {
  return <QuestionnairePrimitive.Error className={cn('mt-3 text-xs font-medium text-destructive', className)} {...props} />;
}

function QuestionnairePrevious({ children = 'Previous', ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Previous>) {
  return <QuestionnairePrimitive.Previous render={<Button variant="outline" />} {...props}>{children}</QuestionnairePrimitive.Previous>;
}

function QuestionnaireNext({ children = 'Next', ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Next>) {
  return <QuestionnairePrimitive.Next render={<Button />} {...props}>{children}</QuestionnairePrimitive.Next>;
}

function QuestionnaireSubmit({ children = 'Submit', ...props }: React.ComponentProps<typeof QuestionnairePrimitive.Submit>) {
  return <QuestionnairePrimitive.Submit render={<Button />} {...props}>{children}</QuestionnairePrimitive.Submit>;
}

export {
  Questionnaire,
  QuestionnaireProgress,
  QuestionnaireItem,
  QuestionnaireTitle,
  QuestionnaireDescription,
  QuestionnaireChoices,
  QuestionnaireChoice,
  QuestionnaireChoiceInput,
  QuestionnaireChoiceLabel,
  QuestionnaireError,
  QuestionnairePrevious,
  QuestionnaireNext,
  QuestionnaireSubmit,
};
